import React from 'react';
import { graphql } from 'gatsby';
import {
  ShopLayout,
} from '../components/Layout';
import {
  ProductList,
} from '../components/shop';
import {
  useMousePosition,
  useDimensions,
  useScrollPosition,
} from '../util/hooks';
import { isClient } from '../util/helpers';

const Shop = (props) => {
  const {
    data: {
      site: {
        siteMetadata,
      },
      page: {
        data: pageData,
      },
      shop,
      categories,
    },
    location,
    pageContext,
  } = props;
  const {
    shopSlug,
  } = siteMetadata;
  const {
    metaTitle,
    metaDescription,
    openGraphImage,
  } = pageData;
  const seoData = {
    metaTitle,
    metaDescription,
    openGraphImage,
  };
  const {
    x: cursorX,
    y: cursorY,
  } = useMousePosition();
  const {
    viewportWidth,
    viewportHeight,
    documentHeight,
  } = useDimensions();
  const viewportTopPos = useScrollPosition();
  if (isClient) document.documentElement.style.setProperty('--bg-colour', '#FFFFF4');
  const pathPrefix = `/${shopSlug}`;
  const productItems = shop && shop.edges.map(product => product.node);
  const categoryItems = categories && categories.edges.map(category => category.node);
  return (
    <ShopLayout
      location={location}
      seoData={seoData}
      cursorX={cursorX}
      cursorY={cursorY}
      viewportWidth={viewportWidth}
      viewportHeight={viewportHeight}
      documentHeight={documentHeight}
      viewportTopPos={viewportTopPos}
    >
      <ProductList
        products={productItems}
        categories={categoryItems}
        siteMetadata={siteMetadata}
        location={location}
        pageContext={pageContext}
        pathPrefix={pathPrefix}
      />
    </ShopLayout>
  );
};

export default Shop;

export const pageQuery = graphql`
  query ShopPageQuery($limit: Int!, $skip: Int!) {
    site {
      siteMetadata {
        shopSlug,
        shopCategorySlug,
      }
    },
    page: prismicShop {
      uid,
      data {
        metaTitle: meta_title {
          html
          text
        },
        metaDescription: meta_description {
          html
          text
        },
        openGraphImage: open_graph_image {
          alt
          copyright
          url
        }
      }
    }
    categories: allShopifyCollection {
      edges {
        node {
          handle
          title
        }
      }
    }
    shop: allShopifyProduct(
      sort: { fields: [createdAt], order: DESC }
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          id
          title
          handle
          createdAt
          images {
            id
            originalSrc
            localFile {
              childImageSharp {
                fluid(maxWidth: 1000) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
          variants {
            price
          }
        }
      }
    }
  }
`;
